import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { APIService } from 'src/app/api/api.service';
import { ForgotPassword } from 'web-api-client/src/lib/generated/kia-authentication-api-client';
import { ToastrService } from 'ngx-toastr';

enum ErrorStates {
  NotSubmitted,
  HasError,
  NoError,
}

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  errorState: ErrorStates = ErrorStates.NotSubmitted;
  errorStates = ErrorStates;
  isSubmitting: boolean = false;

  // private fields
  constructor(
    private fb: FormBuilder,
    private apiService: APIService,
    private toastr: ToastrService,
    private cdRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.initForm();
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.forgotPasswordForm.controls;
  }

  initForm() {
    this.forgotPasswordForm = this.fb.group({
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.email,
          Validators.minLength(3),
          Validators.maxLength(320), // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
        ]),
      ],
    });
  }

  submit() {
    this.isSubmitting = true;
    const request: ForgotPassword = new ForgotPassword();
    request.userName = this.forgotPasswordForm.controls["email"].value;
    request.isTrainingPortalRequest = true;
    this.apiService.getKiaAuthenticationApiClient().postForgotPassword(request).then(result => {
      this.toastr.success('If your email is registered, we will send you a password reset email', 'Success');
      this.isSubmitting = false;
      this.cdRef.detectChanges();
    }).catch(error => {
      if (error.response === 'User did not accept the invite') {
        this.toastr.error(error.response);
      } else {
        this.toastr.success('If your email is registered, we will send you a password reset email', 'Success');
      }
      this.isSubmitting = false;
      this.cdRef.detectChanges();
    });
  }
}
